
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "xmlns": "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24"
  },
  "children": [
    {
      "tag": "defs",
      "children": [
        {
          "tag": "clipPath",
          "attrsMap": {
            "id": "clip-path"
          },
          "children": [
            {
              "tag": "rect",
              "attrsMap": {
                "id": "矩形_11191",
                "data-name": "矩形 11191",
                "class": "cls-1",
                "width": "24",
                "height": "24",
                "transform": "translate(-0.079 -0.422)"
              }
            }
          ]
        }
      ]
    },
    {
      "tag": "g",
      "attrsMap": {
        "id": "蒙版组_232",
        "data-name": "蒙版组 232",
        "class": "cls-2",
        "transform": "translate(0.079 0.422)"
      },
      "children": [
        {
          "tag": "path",
          "attrsMap": {
            "id": "Pool",
            "class": "cls-3",
            "d": "M66.477,124.092a4.05,4.05,0,0,1,3.4,1.5l-2.39,2.375c-.126.125-.126.25-.126.5a.648.648,0,0,0,.252.5l.252.125c.126,0,.252.125.5.25a2.091,2.091,0,0,0,2.39,0,2.869,2.869,0,0,1,3.145,0,2.825,2.825,0,0,0,1.258.375,2.973,2.973,0,0,0,1.635-.625c.252-.125.252-.375.252-.625,0-.125-.126-.25-.252-.375l-1.635-1.625c-1.258-1.5-2.641-2.875-4.025-4.25a6.765,6.765,0,0,0-4.78-1.5.592.592,0,0,0-.629.625v2.125a.945.945,0,0,0,.252.5A.76.76,0,0,0,66.477,124.092Zm.5-2.125a4.2,4.2,0,0,1,3.145,1.125c1.384,1.375,2.767,2.75,4.151,4l1.132,1.125c-.252.125-.5,0-.88-.125a4.414,4.414,0,0,0-4.528,0,.948.948,0,0,1-1.132,0l2.138-2.125c.377,0,.377-.375.252-.625a5.782,5.782,0,0,0-4.151-2.5v-.875Zm8.805,2.5a2.515,2.515,0,0,0,2.516-2.5,2.438,2.438,0,0,0-2.516-2.5,2.584,2.584,0,0,0-2.516,2.375,2.536,2.536,0,0,0,.755,1.875A3.171,3.171,0,0,0,75.785,124.467Zm-.88-3.5a1.145,1.145,0,0,1,.88-.375,1.185,1.185,0,0,1,1.258,1.25,1.348,1.348,0,0,1-1.258,1.25,1.145,1.145,0,0,1-.88-.375,1.414,1.414,0,0,1-.377-1A1.372,1.372,0,0,1,74.9,120.967Zm7.3,10.625c-.126,0-.126,0-.252-.125a4.977,4.977,0,0,0-5.409-.125,1.344,1.344,0,0,1-1.509-.125,4.41,4.41,0,0,0-4.78-.125,1.9,1.9,0,0,1-2.264,0,4.666,4.666,0,0,0-4.277-.25c-.377.125-.755.375-1.132.5v1.375l.5-.25c.377-.125.755-.375,1.132-.5a3.135,3.135,0,0,1,3.145.125,3.263,3.263,0,0,0,3.522,0,3.261,3.261,0,0,1,3.522.125,2.686,2.686,0,0,0,2.893.125,3.609,3.609,0,0,1,4.151,0c.252.125.377.25.629.25a.464.464,0,0,1,.377.125Zm-.126,3.625a4.977,4.977,0,0,0-5.409-.125,1.344,1.344,0,0,1-1.509-.125,4.41,4.41,0,0,0-4.78-.125,1.9,1.9,0,0,1-2.264,0,4.666,4.666,0,0,0-4.277-.25c-.377.125-.755.375-1.132.5v1.375l.5-.25c.377-.125.755-.375,1.132-.5a3.135,3.135,0,0,1,3.145.125,3.263,3.263,0,0,0,3.522,0,3.261,3.261,0,0,1,3.522.125,2.686,2.686,0,0,0,2.893.125,3.609,3.609,0,0,1,4.151,0c.252.125.377.25.629.25a.464.464,0,0,1,.377.125v-1.25Z",
            "transform": "translate(-60.657 -115.889)"
          }
        }
      ]
    }
  ]
})
    }
  